module.exports = __webpack_public_path__ + "img/logo-redcross.c1ec446a.png";